<script setup lang="ts">

import { computed, ref, onMounted, watch } from 'vue'
import { searchOptions } from '@/Composables/use-listing-search'

const MAX_NIGHT = 30
const show = ref(true)
const showCondition = computed(() => {
    return searchOptions.value.nights > MAX_NIGHT && !searchOptions.value.skipDate && show.value
}) 

const openLinkAfterDelay = (): void => {
    setTimeout(() => {
        window.open('https://hostelworld.prf.hn/l/DLOdmBe/', '_blank', 'noopener,noreferrer')
    }, 3000)
}

onMounted(() => {
    if (showCondition.value) {
        openLinkAfterDelay()
    }
})

watch(showCondition, (newValue) => {
    if (newValue) {
        openLinkAfterDelay()
    }
})
</script>

<template>
    <section v-if="showCondition" class="mb-lg-3">
        <div
            class="slot-banner px-4 py-3 slot-banner position-relative"
            style="background: #FFF9DB;"
        >
            <div class="slotBanner mr-2">
                <p class="mb-0 sb-title">
                    Looking for a Stay Longer Than 30 Days?
                </p>
                <p>
                    We list all available hostels on <a
                        href="https://www.hostelz.com/hwlongterm"
                        title="+30 Days Reservations in Hostels - Hostelworld"
                        target="_blank"
                        rel="nofollow"
                    >Hostelworld</a> and <a
                        href="https://www.hostelz.com/bookinglongterm"
                        title="+30 Days Reservations in Hostels - Booking.com"
                        target="_blank"
                        rel="nofollow"
                    >Booking.com</a>. More options? Check these trusted platforms for more long-term stay deals:
                </p>
                <a
                    href="https://www.hostelz.com/vrbolongterm"
                    class="btn btn-danger mr-2"
                    target="_blank"
                    rel="nofollow"
                    title="+30 Days Reservations in Hostels - VRBO"
                >Vrbo.com</a>
                <a
                    href="https://www.hostelz.com/expedialongterm"
                    class="btn btn-danger mr-2"
                    target="_blank"
                    rel="nofollow"
                    title="+30 Days Reservations in Hostels - Expedia.com"
                >Expedia.com</a>
                <a
                    href="https://www.hostelz.com/hotelslongterm"
                    class="btn btn-danger mr-2"
                    target="_blank"
                    rel="nofollow"
                    title="+30 Days Reservations in Hostels - Hotels.com"
                >Hotels.com</a>
            </div>
            <button
                type="button"
                class="slot-banner-close close position-absolute"
                aria-label="Close"
                @click="show = false"
            >
                <span class="the-icon-component" style="width: 24px; height: 24px;"><svg
                    class=""
                    width="24"
                    height="24"
                    stroke="#01949A"
                ><use href="/images/icons.svg#close-icon-2" /></svg></span>
            </button>
        </div>
    </section>
</template>

<style scoped lang="scss">
.slot-banner-close {
    top: 10px;
    right: 10px;

    outline: none;
}
</style>